import React from 'react'
import { connect } from 'react-redux'

import Icon from '../components/Icon'
import Button from '../components/Button'
// import CompetitorsTable from '../components/CompetitorsTable'
import TestimonialsCarousel from '../components/TestimonialsCarousel'
import PageHeader from '../components/PageHeader'
import PageSection from '../components/PageSection'
import GenericCtaModule from '../components/GenericCtaModule'
import EnterpriseContactModal from '../components/EnterpriseContactModal'
import VerticalsCarousel from '../components/VerticalsCarousel'
import WordpressImage from '../components/WordpressImage'

import { showModal } from '../../reducers/modal'

import { trackEvent } from '../../utils/tracking'

const WPvoiceProductsSectionTitle = 'Voice Products'
const WPvoiceProductsSectionSubtitle =
  'All our voice products run fully on-device in the Edge, without any cloud backend. They can be used independently as separate modules, and can offer even higher performances when combined.'
const WPvoiceProducts = [
  {
    title: 'Custom Wake Word',
    subtitle:
      'Get your own universal custom wake word for your assistant. It uses Deep Learning to robustly detect when someone is triggering the assistant, without the need to train it for each individual.',
    icon: 'ringing-bell'
  },
  {
    title: 'Wake Word Gateway',
    subtitle:
      'Link multiple wake word with different assistants, including external ones such as Amazon Alexa or Google Assistant. The Snips Wake Word Gateway will recognize which assistant is triggered and channel the query to the right place, all from within your own product.',
    icon: 'bells'
  },
  {
    title: 'eASR: Edge Automatic Speech Recognition',
    subtitle:
      'Use our Speech Recognition engine to accurately transcribe voice into text, regardless of accent or surrounding noise. It can further be improved by linking it to our eNLU engine, specializing the language models to fit your specific product use case. ',
    icon: 'mic'
  },
  {
    title: 'eNLU: Edge Natural Language Understanding',
    subtitle:
      'Go beyond voice commands by adding natural language understanding capabilities to your assistants. Use it in combination with our Data Generation Service and ASR to get performances beyond those of traditional cloud providers.',
    icon: 'nlu-dot'
  },
  {
    title: 'Dialog Manager',
    subtitle:
      'Build rich multi-turn voice interactions for your product. Our dialog manager will handle the slot filling and intent disambiguation, providing a more natural way of talking to your assistant.',
    icon: 'bubbles-dialog'
  },
  {
    title: 'Data Generation',
    subtitle:
      'Supercharge the performance of your assistants by generating thousands of utterances to train its NLU models. Simply describe your intents, add a few example queries, and our proprietary human-in-the-loop algorithms will do the rest! Your data can then be exported to be used in other NLU and chatbot platforms.',
    icon: 'data-generation'
  }
]

const WPindustrySolutionsSectionTitle = 'Industry Solutions'
const WPindustrySolutionsSectionSubtitle =
  'Our solutions leverage our proprietary data-generation technology to pre-train assistants with tens of thousands of queries, instead of the few dozens that are typical of other platforms. Snips assistants are trained to fit your brand, product and customer experience, ensuring that you are providing a cutting edge product without sacrificing user privacy. Provide a whole new level of user experience and grow from your data instead of giving it up to someone else.'
const industrySolutionsButtonLabel = 'Enquire about other verticals'

function VoiceProductsList ({ voiceProducts }) {
  return (
    <ul className='enterprise-page__voice-products__list'>
      {voiceProducts.map(({ title, subtitle, icon }) => {
        return (
          <li
            key={title}
            className='enterprise-page__voice-products__list-item mb2'
          >
            <Icon
              icon={icon}
              className='enterprise-page__voice-products__icon mr2 mb2'
            />
            <h3 className='enterprise-page__voice-products__list-item__title mb2'>
              {title}
            </h3>
            <p className='enterprise-page__voice-products__list-item__subtitle text-para'>
              {subtitle}
            </p>
          </li>
        )
      })}
    </ul>
  )
}

export const EnterprisePage = ({
  data: {
    acf: {
      // NOT USED
      headerTitle,
      headerSubtitle,
      headerBtnLabel,
      //
      // betweenImage,
      //
      // uniqueTitle,
      // uniqueReasons,
      //
      // mediaSections,

      industrySolutionsVerticalsCarousel,

      testimonialSlides,

      partnersSectionTitle,
      partnersSectionData,
      //
      // servicesTitle,
      // serviceItems,
      //
      // competitorsSectionTitle,
      // competitorsSectionSubtitle,

      // pressLinks: pressLinksData,

      // competitorsSectionTable,
      gdprTitle,
      gdprContent,
      gdprBtnLabel,
      gdprLink,
      bottomCtaTitle,
      bottomCtaSubtitle,
      bottomCtaButtonLabel
    }
  },
  showModal
}) => {
  return (
    <main className='enterprise-page main maxw-xxlarge mx-auto px2'>
      <PageHeader
        title={headerTitle}
        extraClass='enterprise-page__page-header bg-white'
      >
        <p className='col-10 md-col-8 lg-col-6 text-para mx-auto mb3'>
          {headerSubtitle}
        </p>
        {headerBtnLabel && (
          <Button
            className='enterprise-page-hero-section__actions__button button button--primary mb3'
            onClick={() => {
              trackEvent('EnterpriseContactModal', 'EnterpriseHeroSection')
              showModal(<EnterpriseContactModal />)
            }}
          >
            {headerBtnLabel}
          </Button>
        )}
      </PageHeader>

      <PageSection extraClass='bg-white enterprise-page__voice-products__body'>
        <div className='col-12 lg-col-10 mx-auto bg-white p3'>
          <h2 className='h2 mb2 center'>{WPvoiceProductsSectionTitle}</h2>
          <p className='text-para mb4 maxw-text mx-auto center'>
            {WPvoiceProductsSectionSubtitle}
          </p>
          <VoiceProductsList voiceProducts={WPvoiceProducts} />
        </div>
      </PageSection>

      <PageSection extraClass='enterprise-page__industry-solutions'>
        <div className='enterprise-page__industry-solutions__header col-10 md-col-6 mx-auto center p2 mb4'>
          <h2 className='h2 mb2 white'>{WPindustrySolutionsSectionTitle}</h2>
          <p className='text-para text-para--light'>
            {WPindustrySolutionsSectionSubtitle}
          </p>
        </div>
        <VerticalsCarousel
          extraClass='mb4'
          slides={industrySolutionsVerticalsCarousel}
        />
        <div className='center white mb4'>
          <Button
            className='button button--outline bg-primary'
            onClick={() => {
              trackEvent(
                'EnterpriseContactModal',
                'EnterpriseIndustrySolutionSection'
              )
              showModal(<EnterpriseContactModal />)
            }}
          >
            {industrySolutionsButtonLabel}
          </Button>
        </div>
      </PageSection>

      {testimonialSlides && (
        <PageSection extraClass='enterprise-page__competitors bg-white text-color'>
          <div className='col-10 lg-col-12 mx-auto center '>
            <TestimonialsCarousel
              extraClass='lg-col-8 mx-auto enterprise-page__testimonials-section__carousel overflow-hidden mb4'
              slides={testimonialSlides}
            />

            {partnersSectionData &&
              partnersSectionData.length > 0 && (
                <section className='mb4'>
                  {partnersSectionTitle && (
                    <h2 className='center mb2 h2'>{partnersSectionTitle}</h2>
                  )}
                  <div className='maxw-large mx-auto flex flex-wrap justify-center'>
                    {partnersSectionData.map(({ image, label, url }, idx) => (
                      <div className='flex-none p2 col-6 lg-col-4'>
                        <WordpressImage
                          className='enterprise-page__partner-image'
                          key={idx}
                          img={image}
                        />
                      </div>
                    ))}
                  </div>
                </section>
              )}
          </div>
        </PageSection>
      )}
      <PageSection extraClass='enterprise-page__gdpr white'>
        <div className='col-10 maxw-text mx-auto center mb4'>
          <h2 className='enterprise-page__gdpr__title h2 white center'>
            {gdprTitle}
          </h2>
          <div
            className='text-para text-para--light enterprise-page__gdpr__subtitle relative'
            dangerouslySetInnerHTML={{ __html: gdprContent }}
          />
          <div className='flex justify-center'>
            <Button
              href={gdprLink}
              target='_blank'
              className='button button--outline'
            >
              {gdprBtnLabel}
            </Button>
          </div>
        </div>
      </PageSection>

      <PageSection extraClass='overflow-hidden bg-white'>
        <GenericCtaModule
          headerTitle={bottomCtaTitle}
          subtitle={bottomCtaSubtitle}
          imageUrl='/static/images/cafe-girl.gif'
          buttonLabel={bottomCtaButtonLabel}
          buttonOnClick={e => {
            e.preventDefault()
            trackEvent(
              'EnterpriseContactModal',
              'EnterprisePageBottomCTASection'
            )
            showModal(<EnterpriseContactModal />)
          }}
          buttonForceAnchorElement={false}
          secondaryEnterpriseButton={false}
        />
      </PageSection>
    </main>
  )
}

export default connect(null, { showModal })(EnterprisePage)



// WEBPACK FOOTER //
// ./frontend/scripts/react/pages/EnterprisePage.js